import styled from '@nobia/zeus-components/lib/styled'

const spacing =
  ({ theme }) =>
  (space) =>
    space && `${theme.rem(theme.spacings[space])}`

const toResponsiveStyle =
  ({ theme }) =>
  (name, space) => {
    if (!space) {
      return undefined
    }
    if (typeof space === 'string') {
      return `${name}: ${spacing({ theme })(space)}`
    }

    let string = ''
    if (space.xs) {
      string += `@media (min-width: ${theme.rem(theme.breakpoints.xs)}) {
  ${name}: ${spacing({ theme })(space.xs)};
}`
    }
    if (space.sm) {
      string += `@media (min-width: ${theme.rem(theme.breakpoints.sm)}) {
  ${name}: ${spacing({ theme })(space.sm)};
}`
    }
    if (space.md) {
      string += `@media (min-width: ${theme.rem(theme.breakpoints.md)}) {
  ${name}: ${spacing({ theme })(space.md)};
}`
    }
    if (space.lg) {
      string += `@media (min-width: ${theme.rem(theme.breakpoints.lg)}) {
  ${name}: ${spacing({ theme })(space.lg)};
}`
    }
    if (space.lg) {
      string += `@media (min-width: ${theme.rem(theme.breakpoints.lg)}) {
  ${name}: ${spacing({ theme })(space.lg)};
}`
    }

    return string
  }

export const Box = styled.div`
  ${(p) => toResponsiveStyle(p)('margin', p.m)};
  ${(p) => toResponsiveStyle(p)('margin-left', p.mx)};
  ${(p) => toResponsiveStyle(p)('margin-right', p.mx)};
  ${(p) => toResponsiveStyle(p)('margin-top', p.my)};
  ${(p) => toResponsiveStyle(p)('margin-bottom', p.my)};
  ${(p) => toResponsiveStyle(p)('margin-top', p.mt)};
  ${(p) => toResponsiveStyle(p)('margin-bottom', p.mb)};
  ${(p) => toResponsiveStyle(p)('margin-left', p.ml)};
  ${(p) => toResponsiveStyle(p)('margin-right', p.mr)};

  ${(p) => toResponsiveStyle(p)('padding', p.p)};
  ${(p) => toResponsiveStyle(p)('padding-left', p.px)};
  ${(p) => toResponsiveStyle(p)('padding-right', p.px)};
  ${(p) => toResponsiveStyle(p)('padding-top', p.py)};
  ${(p) => toResponsiveStyle(p)('padding-bottom', p.py)};
  ${(p) => toResponsiveStyle(p)('padding-top', p.pt)};
  ${(p) => toResponsiveStyle(p)('padding-bottom', p.pb)};
  ${(p) => toResponsiveStyle(p)('padding-left', p.pl)};
  ${(p) => toResponsiveStyle(p)('padding-right', p.pr)};

  position: ${(p) => p.position};
  background-color: ${(p) => p.background && p.theme.colors[p.background]};
  color: ${(p) => p.color && p.theme.colors[p.color]};
  display: ${(p) => p.display};
  flex: ${(p) => p.flex};
  flex-grow: ${(p) => p.flexGrow};
  flex-shrink: ${(p) => p.flexShrink};
  flex-basis: ${(p) => p.flexBasis};
  flex-direction: ${(p) => p.flexDirection};
  flex-wrap: ${(p) => p.flexWrap};
  align-items: ${(p) => p.alignItems};
  justify-content: ${(p) => p.justifyContent};
  width: ${(p) => p.width};
  height: ${(p) => p.height};
`
